<template>
  <div>
    <VacancyStoreDialog>
      <template v-slot:activator="{ show }">
        <template v-if="link">
          <a @click="newVacancy(show)">
            <slot>{{ $t('newVacancy') }}</slot>
          </a>
        </template>
        <VBtn
          v-else-if="canStoreVacancies"
          color="success"
          dark
          @click="createVacancy"
        >
          <slot>{{ $t('newVacancy') }}</slot>
        </VBtn>
        <VBtn
          v-else
          color="success"
          dark
          @click="newVacancy(show)"
        >
          <slot>{{ $t('newVacancy') }}</slot>
        </VBtn>
      </template>
    </VacancyStoreDialog>
    <VDialog
      v-model="dialogMaximumVacancies"
      persistent
      max-width="500"
    >
      <DialogLimitedVacancies
        :plan-title="planTitle"
        :limited-vacancies="limitedVacancies"
        @close="cancelDialogMaximumVacancies"
      />
    </VDialog>
    <VDialog
      v-model="dialogExpiredTariff"
      persistent
      max-width="600"
    >
      <DialogExpiredTariff @close="cancelDialogExpiredTariff" />
    </VDialog>
  </div>
</template>

<script>
import usePermissions from '@/compositions/usePermissions';
import {
  ref, computed, onMounted,
} from '@vue/composition-api';
import DialogLimitedVacancies from '@/components/DialogLimitedVacancies.vue';
import DialogExpiredTariff from '@/components/DialogExpiredTariff.vue';
import useAccount from '@/compositions/accounting/useAccount';
import useVacancies from '@/compositions/useVacancies';
import useSubscription from '@/compositions/accounting/useSubscription';
import VacancyStoreDialog from './VacancyStoreDialog.vue';

export default {
  name: 'VacancyStoreButton',
  components: { DialogLimitedVacancies, DialogExpiredTariff, VacancyStoreDialog },
  props: {
    link: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root: { $router } }) {
    const { canStoreVacancies } = usePermissions();
    const { account, fetchIfNull } = useAccount();
    const { notArchivedVacancies } = useVacancies();
    const { isExpired } = useSubscription();

    const dialogMaximumVacancies = ref(false);
    const dialogExpiredTariff = ref(false);

    const planTitle = computed(() => account.value?.plan.title);
    const maximumVacancies = computed(() => account.value?.maximumVacancies);
    const trialMaximumVacancies = computed(() => account.value?.trialMaximumVacancies);

    const notArchivedVacanciesLength = computed(() => notArchivedVacancies.value?.length);

    const limitedVacancies = computed(() => {
      if (trialMaximumVacancies.value && account.value.trialEnabled && (trialMaximumVacancies.value <= notArchivedVacanciesLength.value)) {
        return trialMaximumVacancies.value;
      }

      if (maximumVacancies.value && (maximumVacancies.value <= notArchivedVacanciesLength.value)) {
        return maximumVacancies.value;
      }
    });

    function openDialogMaximumVacancies() {
      dialogMaximumVacancies.value = true;
    }

    function cancelDialogMaximumVacancies() {
      dialogMaximumVacancies.value = false;
    }

    function cancelDialogExpiredTariff() {
      dialogExpiredTariff.value = false;
    }

    function createVacancy() {
      if (isExpired.value) {
        dialogExpiredTariff.value = true;
        return;
      }
      if (maximumVacancies.value && (maximumVacancies.value <= notArchivedVacanciesLength.value)
          || (account.value.trialEnabled && trialMaximumVacancies.value && (trialMaximumVacancies.value <= notArchivedVacanciesLength.value))
      ) {
        openDialogMaximumVacancies();
        return;
      }

      return $router.push({ name: 'vacancy-store' });
    }
    function newVacancy(showDialog) {
      if (isExpired.value) {
        dialogExpiredTariff.value = true;
        return;
      }

      if (maximumVacancies.value && (maximumVacancies.value <= notArchivedVacanciesLength.value)
          || (account.value.trialEnabled && trialMaximumVacancies.value && (trialMaximumVacancies.value <= notArchivedVacanciesLength.value))
      ) {
        openDialogMaximumVacancies();
        return;
      }

      if (canStoreVacancies.value) {
        return $router.push({ name: 'vacancy-store' });
      }

      showDialog();
      return null;
    }

    onMounted(async () => {
      await fetchIfNull();
    });

    return {
      canStoreVacancies,
      newVacancy,
      createVacancy,
      dialogMaximumVacancies,
      cancelDialogMaximumVacancies,
      dialogExpiredTariff,
      cancelDialogExpiredTariff,
      maximumVacancies,
      planTitle,
      limitedVacancies,
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  newVacancy: New job
</i18n>

<i18n locale="ru" lang="yaml">
  newVacancy: Новая вакансия
</i18n>
